import { get } from "@ember/object"
import Route from "@ember/routing/route"
import { inject as service } from "@ember/service"

export default class FiscalGroupRoute extends Route {
  @service("ember-store")
  store

  model(params) {
    return get(this, "store").find("fiscal-group", params.id)
  }
}
